const cloneRows = rows => JSON.parse(JSON.stringify(rows))
const span = (cell, name) => Math.max(1, Number(cell && cell[name]) || 1)

export function mergeTableCells(rows, first, last) {
  const top = Math.min(first.row, last.row)
  const bottom = Math.max(first.row, last.row)
  const left = Math.min(first.col, last.col)
  const right = Math.max(first.col, last.col)
  if (top === bottom && left === right) return { error: 'Sélectionnez au moins deux cellules à fusionner.' }
  const next = cloneRows(rows)
  const values = []
  for (let row = top; row <= bottom; row += 1) {
    for (let col = left; col <= right; col += 1) {
      const cell = next[row] && next[row].cells[col]
      if (!cell || cell.merged || span(cell, 'rowspan') > 1 || span(cell, 'colspan') > 1 || (cell.subcells && cell.subcells.length)) {
        return { error: 'La sélection contient déjà une cellule fusionnée ou divisée. Séparez-la avant de fusionner.' }
      }
      if (String(cell.value || '').trim()) values.push(String(cell.value).trim())
    }
  }
  const anchor = next[top].cells[left]
  anchor.value = values.join(' · ')
  anchor.rowspan = bottom - top + 1
  anchor.colspan = right - left + 1
  for (let row = top; row <= bottom; row += 1) {
    for (let col = left; col <= right; col += 1) {
      if (row !== top || col !== left) next[row].cells[col] = { value: '', merged: true }
    }
  }
  return { rows: next }
}

export function splitTableCell(rows, position, direction) {
  const next = cloneRows(rows)
  const cell = next[position.row] && next[position.row].cells[position.col]
  if (!cell || cell.merged) return { error: 'Choisissez une cellule visible à diviser.' }
  const rowCount = span(cell, 'rowspan')
  const colCount = span(cell, 'colspan')
  if (direction === 'vertical' && colCount > 1) {
    const left = Math.floor(colCount / 2)
    const right = colCount - left
    cell.colspan = left
    next[position.row].cells[position.col + left] = { value: '', rowspan: rowCount, colspan: right }
    return { rows: next }
  }
  if (direction === 'horizontal' && rowCount > 1) {
    const upper = Math.floor(rowCount / 2)
    const lower = rowCount - upper
    cell.rowspan = upper
    next[position.row + upper].cells[position.col] = { value: '', rowspan: lower, colspan: colCount }
    return { rows: next }
  }
  const sideBySide = direction === 'vertical'
  if (cell.subcells && cell.subcells.length) {
    if (Boolean(cell.horizontal) !== sideBySide) return { error: 'Cette cellule est déjà divisée dans l’autre sens.' }
    cell.subcells.push({ value: '' })
  } else {
    cell.subcells = [{ value: cell.value || '' }, { value: '' }]
    cell.value = ''
    cell.horizontal = sideBySide
  }
  return { rows: next }
}

export function canRemoveTableRow(rows, rowIndex) {
  if (!Array.isArray(rows) || rows.length <= 2 || rowIndex <= 0) return false
  for (let row = 0; row < rows.length; row += 1) {
    for (const cell of rows[row].cells || []) {
      if (row === rowIndex && cell.merged) return false
      if (row < rowIndex && row + span(cell, 'rowspan') > rowIndex) return false
      if (row === rowIndex && span(cell, 'rowspan') > 1) return false
    }
  }
  return true
}
